import { ApiError } from '@lib/api/api-response';

import { parseApiErrorResponse } from './parse-api-error-response';

/**
 * Builds an `ApiError` from a failed `Response`: the server's message (or
 * `Request failed (HTTP n)`), the real status (so the global Clerk-401 refresh
 * gate fires), the parsed body, and the body's machine-readable `code` when it
 * has one, for callers that map codes to copy.
 */
export async function apiErrorWithCode(response: Response): Promise<ApiError> {
  const { reason, body } = await parseApiErrorResponse(response);
  // Only structured bodies carry usable detail (and a `code`).
  const responseBody = body && typeof body === 'object' ? body : undefined;
  return new ApiError(
    reason || `Request failed (HTTP ${response.status})`,
    response.status,
    responseBody,
    readErrorCode(responseBody)
  );
}

/** The API error body's optional string `code` (e.g. `proof_already_submitted`). */
function readErrorCode(body: object | undefined): string | undefined {
  const code = body && 'code' in body ? body.code : undefined;
  return typeof code === 'string' ? code : undefined;
}
